import { motion } from "framer-motion";
import { Coffee } from "lucide-react";

const STAMPS_TOTAL = 20;
const STAMPS_FILLED = 13;

export const StampCard = () => {
  return (
    <div className="relative w-full max-w-md mx-auto">
      <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-primary/20 via-accent/10 to-transparent blur-2xl" />

      <motion.div
        initial={{ rotate: -2 }}
        animate={{ rotate: [-2, 2, -2] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        className="relative rounded-3xl bg-card border border-border/60 p-8 shadow-2xl shadow-primary/10"
      >
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="text-xs uppercase tracking-wider text-muted-foreground">
              Café Atlas — Marrakech
            </p>
            <h3 className="text-xl font-bold text-foreground mt-1">
              Carte de fidélité
            </h3>
          </div>
          <div className="rounded-full bg-primary/10 p-3">
            <Coffee className="h-5 w-5 text-primary" />
          </div>
        </div>

        <div className="grid grid-cols-5 gap-3 mb-6">
          {Array.from({ length: STAMPS_TOTAL }).map((_, i) => {
            const filled = i < STAMPS_FILLED;
            return (
              <motion.div
                key={i}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.3 + i * 0.04, type: "spring", stiffness: 200 }}
                className={`aspect-square rounded-full flex items-center justify-center text-xs font-bold ${
                  filled
                    ? "bg-primary text-primary-foreground shadow-md shadow-primary/30"
                    : "bg-muted/60 text-muted-foreground border border-dashed border-border"
                }`}
              >
                {filled ? "✓" : i + 1}
              </motion.div>
            );
          })}
        </div>

        <div className="flex items-center justify-between rounded-xl bg-gradient-to-r from-primary/5 to-accent/5 p-4 border border-primary/10">
          <div>
            <p className="text-sm text-muted-foreground">Récompense à débloquer</p>
            <p className="text-base font-bold text-foreground">
              <bdi>{STAMPS_TOTAL - STAMPS_FILLED}</bdi> visites restantes
            </p>
          </div>
          <div className="text-3xl">🎁</div>
        </div>
      </motion.div>
    </div>
  );
};
